import { render, staticRenderFns } from "./orderDriverLineDetails.vue?vue&type=template&id=a19971e2"
import script from "./orderDriverLineDetails.vue?vue&type=script&lang=js"
export * from "./orderDriverLineDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDriverLineDetails.vue?vue&type=style&index=0&id=a19971e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports